import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, LogicX, NavX, ResponsiveX, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XImage, XText } from "IZOX/_X";
import { QForm } from "IZOX/BLOCKS/Libs";
import { QFDigitBox, QFPassword, QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import Styles from "__SYSDefault/Styles";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import _ from "lodash";
import CountDownLite from "IZOX/BLOCKS/Libs/RefreshTimeCount/CountDownLite";
import Password from "shared/Password";
import FooterM from "shared/FooterM";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PForgotPassword extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      step: "email",
      epFormValid: false,
      formData: {},
      canResend: false
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PForgotPassword.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  onMountCountDown = (callbacks) => {
    this.MountCountDown = callbacks;
  }

  _toStep = (step) => {
    this.setState({
      step: step
    });
  }

  _toLogin = () => {
    let {history} = this.props;
    NavX.Goto(history, "/Login");
  }

  _updateFormData = (formValue, callback = null) => {
    let {formData} = this.state;
    let newFormData = {
     ...formData,
     ...formValue
    };
    this.setState({
      formData: newFormData
    }, callback);
    return newFormData;
  }

  _checkEPFormValid = (formValue) => {    
    if(!LogicX.CheckAllValid(formValue, 
      ["email"], 
        o => !LogicX.isNullOrUndefined(o)
      )){
      return {
        Success: false,
        error: {
          EN: "Some fields are empty.",
          TC: "有些欄位沒有填妥"
        }
      };
    }
    return {
      Success: true
    };
  }

  _checkPasswordFormValid = (formValue) => {    
    
    let errors = Password.CheckIfErrors(formValue, "password");

    if(!_.isEmpty(errors)){
      let msgEN = _.map(errors, o => LocaleX.Parse(o, undefined, "EN")).join("\n");
      let msgTC = _.map(errors, o => LocaleX.Parse(o, undefined, "TC")).join("\n");
      return {
        Success: false,
        error: {
          EN: "Password must be:\n" + msgEN,
          TC: "密碼必需為:\n" + msgTC
        }
      };
    }

    let valid = ZValidate.CheckAllFields(formValue, 
      ["password", "confirmPassword", "email"],
      "required"
    );

    if(!valid){
      return {
        Success: false,
        error: {
          EN: "Some fields are empty.",
          TC: "有些欄位沒有填妥"
        }
      };
    }
    
    if(!Accessor.IsAllFieldIdentical(formValue, ["password", "confirmPassword"])){
      return {
        Success: false,
        error: {
          EN: "Password not match.",
          TC: "密碼不匹配"
        }
      };
    }

    return {
      Success: true
    };
  }

  _request = async () => {
    let {formData} = this.state;
    let {Success, error} = this._checkEPFormValid(formData);
    if(error) GFunc.Alert(error, "error");
    if(!Success) return;
    
    let res = await APIExpress.Login.ForgotPassword(formData);
    if(!res.Success){
      GFunc.Alert(res.payload?.message, "error");
      return;
    }
    let {requireOTP, userID, requestID} = res.payload;
    if(requireOTP){
      this._updateFormData({
        userID: userID,
        requestID: requestID
      });
      this._toStep("OTP");
    }
  }

  _changepassword = async () => {
    let {formData} = this.state;
    let {Success, error} = this._checkPasswordFormValid(formData);
    
    if(error){
      this.setState({
        error: error
      });
    }
    if(!Success) return;

    let authCode = Accessor.Get(formData, "authCode");
    let password = Accessor.Get(formData, "password");
    
    let res = await APIExpress.AuthCode.ResetPassword(authCode, password);
    if(!res.Success){
      GFunc.Alert(res.payload?.message, "error");
      return;
    }
    this._toStep("End");
  }

  _back = () => {
    let {history} = this.props;
    NavX.Goto(history, "/Login");
  }

  _autoVerifyOTP = async (otp) => {
    let { formData } = this.state;

    let userID = Accessor.Get(formData, "userID");
    let requestID = Accessor.Get(formData, "requestID");

    let res = await APIExpress.OTP.Verify(userID, requestID, "ResetPassword", otp);
    let {Success, payload} = res;

    if(Success){
      let authCode = payload;
      this._updateFormData({
        authCode: authCode
      }, () => {
        this._toStep("newpassword");
      });

    }else{
      this.MountQFOTP?.Clear?.();
    }
  }

  _canResend = () => {
    this.setState({
      canResend: true
    });
  }

  _resendOTP = async () => {
    let { formData } = this.state;
    let userID = Accessor.Get(formData, "userID");
    let res = await APIExpress.OTP.Resend(userID, "ResetPassword");
    let {Success, payload} = res;
    if(!Success){
      return;
    }

    this.MountCountDown?.Reset?.();
    this.setState({
      canResend: false
    });
    
    let { requestID } = payload;
    this._updateFormData({
      requestID: requestID
    });
  }

  onMountQFEmail = (callbacks) => {
    this.MountQFEmail = callbacks;
  }

  renderEmail(){
    let {epFormValid, error} = this.state;
    return (
      <QForm width={416} fullHeight VAlign="^" pT={80}
        spacing={24} onMounted={this.onMountQFEmail}
        onChange={(formValue) => {
          let _new = this._updateFormData(formValue);
          let {Success, error} = this._checkEPFormValid(_new);
          this.setState({
            epFormValid: Success,
            error: error
          });
        }}
        >
        <VStack spacing={8}>
          <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold>
            {LocaleX.Parse({
              EN: "Forgot Your Password?",
              TC: "忘記密碼?"
            })}
          </XText>
          <XText color={ColorX.CSS("pureWhite")} textAlign="|" newLine>
            {LocaleX.Parse({
              EN: "Enter your Login Username.\nThen we will send to you one-time code to reset password.",
              TC: "輸入您的登錄用戶名。\n然後我們將向您發送一次性代碼以重置密碼。",
            })}
          </XText>
        </VStack>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Login Username",
                TC: "登錄用戶名"
              })}
            </XText>
            <XText fontSize={12} color={ColorX.CSS("Blood")}>
              {"*"}
            </XText>
          </HStack>
          <QFText
            name="email"
            fontSize={14}
            p={12}
            bColor={ColorX.CSS("NotQuiteWhite")}
            placeholder={LocaleX.Parse({
              EN: "Please enter your email here.",
              TC: "請在此輸入您的電子郵件。",
            })}
            />
        </VStack>
        <HStack>
          <XButton {...Styles.QFBtnCancel} fullWidth
            onPress={this._back}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Cancel",
                  TC: "取消"
                })}
              </XText>
            </HStack>
          </XButton>
          <XButton {...Styles.QFBtn} fullWidth
            onPress={this._request} disabled={!epFormValid}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Next",
                  TC: "下一步"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
        {!_.isEmpty(error)
          && 
          <XText color={ColorX.CSS("Blood")} fontSize={12} textAlign="[" fullWidth newLine>
            {"*" + LocaleX.Parse(error)}
          </XText>
        }
      </QForm>
    );
  }

  renderOTP(){
    let {canResend} = this.state;
    return (
      <QForm spacing={24} fullHeight VAlign="-" pB={120} onMounted={this.onMountQFOTP}>
        <VStack>
          <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold>
            {LocaleX.Parse({
              EN: "Verify Your Account",
              TC: "驗證您的帳戶"
            })}
          </XText>
          <XText fontSize={14} color={ColorX.CSS("pureWhite")}>
            {LocaleX.Parse({
              EN: "Enter the 6-digit verification code sent to your registered email address",
              TC: "輸入發送到您註冊電子郵件地址的 6 位驗證碼"
            })}
          </XText>
        </VStack>
        <QFDigitBox onDigitEnd={this._autoVerifyOTP} 
          digit={6} name="otp"
          color={ColorX.CSS("Stone")}
          fontSize={30}
          p={12}
          bColor={ColorX.CSS("NotQuiteWhite")}/>
        <VStack>
          <XText fontSize={14} color={ColorX.CSS("pureWhite")}>
            {LocaleX.Parse({
              EN: "Didn't receive one-time code?",
              TC: "沒有收到一次性代碼？"
            })}
          </XText>
          <XButton onPress={this._resendOTP} disabled={!canResend}>
            <HStack>
              <XText color={ColorX.CSS("DeepBlueSea")} fontSize={16} bold>
                {LocaleX.Parse({
                  EN: "Resend",
                  TC: "重發"
                })}
              </XText>
              {!canResend && 
                <HStack fitWidthToContent>
                  <XText>{"("}</XText>
                  <CountDownLite onMounted={this.onMountCountDown}
                    countDown={60} onTimeUp={this._canResend}/>
                  <XText>{")"}</XText>
                </HStack>}
            </HStack>
          </XButton>
          
        </VStack>
      </QForm>
    );
  }

  renderNewPassword(){
    let {epFormValid, error} = this.state;
    return (
      <QForm width={416} fullHeight VAlign="^" pT={30} 
        spacing={16} onMounted={this.onMountQFEmailPassword}
        onChange={(formValue) => {
          let _new = this._updateFormData(formValue);
          let {Success, error} = this._checkPasswordFormValid(_new);
          this.setState({
            epFormValid: Success,
            error: error
          });
        }}>
        <XImage source="/Images/home/logoV.png"/>
        <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold>
          {LocaleX.Parse({
            EN: "Reset Password",
            TC: "重置密碼"
          })}
        </XText>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "New Password",
                TC: "新密碼"
              })}
            </XText>
            <XText fontSize={12} color={ColorX.CSS("Blood")}>
              {"*"}
            </XText>
          </HStack>
          <QFPassword
            name="password"
            fontSize={14}
            p={12}
            bColor={ColorX.CSS("NotQuiteWhite")}
            placeholder={LocaleX.Parse({
              EN: "Please enter your password here.",
              TC: "請在此輸入您的密碼。",
            })}
            />
        </VStack>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Confirm Password",
                TC: "確認密碼"
              })}
            </XText>
            <XText fontSize={12} color={ColorX.CSS("Blood")}>
              {"*"}
            </XText>
          </HStack>
          <QFPassword
            name="confirmPassword"
            fontSize={14}
            p={12}
            bColor={ColorX.CSS("NotQuiteWhite")}
            placeholder={LocaleX.Parse({
              EN: "Please enter your password here.",
              TC: "請在此輸入您的密碼。",
            })}
            />
        </VStack>
        <HStack>
          <XButton {...Styles.QFBtnCancel} fullWidth
            onPress={this._back}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Cancel",
                  TC: "取消"
                })}
              </XText>
            </HStack>
          </XButton><XButton {...Styles.QFBtn} fullWidth
            onPress={this._changepassword} disabled={!epFormValid}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Next",
                  TC: "下一步"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
        {!_.isEmpty(error)
          && 
          <XText color={ColorX.CSS("Blood")} 
            fontSize={12} textAlign="[" fullWidth newLine>
            {"*" + LocaleX.Parse(error)}
          </XText>
        }
      </QForm>
    );
  }

  renderEnd(){
    return (
      <VStack fullHeight VAlign="-" spacing={24}>
        <XText fontSize={32} color={ColorX.CSS("pureWhite")}>
          {LocaleX.Parse({
            EN: "Password reset Successfully",
            TC: "密碼重置成功"
          })}
        </XText>
        <XText fontSize={14} color={ColorX.CSS("pureWhite")} textAlign="|" newLine>
          {LocaleX.Parse({
            EN: "Thanks for taking care of that.",
            TC: "謝謝你的關注。"
          })}
        </XText> 
        <XButton {...Styles.QFBtn} width={200} onPress={this._toLogin}>
          <HStack>
            <XText>
              {LocaleX.Parse({
                EN: "Done",
                TC: "完成"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderStep(){
    let {step} = this.state;
    switch(step){
      default: 
      case "email": return this.renderEmail();
      case "OTP": return this.renderOTP();
      case "newpassword": return this.renderNewPassword();
      case "End": return this.renderEnd();
    }
  }

  render(){
    return (
      <VStack flexGrow={1} bgColor={ColorX.CSS("Grass")} fullWidth fullHeight>
        <XImage source="/Images/static/pattern.png" noResize maxWidth={"50%"} height={"auto"}
          position="absolute" style={{bottom: 0, right: 0}} zIndex={0}/>
        {this.renderStep()}
        {ResponsiveX.Split({0: () => <FooterM/>, [SysConfig.WebUIWidth]: () => null})}
      </VStack>
    );
  }

}

export default withRouter(observer(PForgotPassword));
